import { useCallback, useState } from 'react';

import { useAgenda } from '@app/hooks/useAgenda';
import { useLogoImage } from '@app/hooks/useLogoImage';
import { useOrderable } from '@app/hooks/useOrderable';
import { formFields, getEventPayload, nonRequiredFields } from '@app/utils/eventUtils';
import { formatNonRequiredFields, validateFormFields } from '@app/utils/validateUtils';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';
import CreateView from '@app/components/common/views/CreateView';

import { EventForm } from './EventForm';

export const CreateEvent = () => {
  const [isImport, setIsImport] = useState(false);
  const { logoImage: sponsorLogo, handleChangeImageLogo: handleChangeSponsorLogo } = useLogoImage();
  const { logoImage: eventLogo, handleChangeImageLogo: handleChangeEventLogo } = useLogoImage();

  const { selected, handleChangeSelected, moveCard } = useOrderable();
  const { agenda, rowModesModel, handleChangeAgenda, handleChangeRowModesModel, handleClickAddAgenda } = useAgenda();

  const validate = useCallback((values: GenericObject) => validateFormFields({ fields: formFields, values }), []);

  const transform = (values: GenericObject) => {
    formatNonRequiredFields(values, nonRequiredFields);

    return getEventPayload(values, agenda, selected, sponsorLogo, eventLogo);
  };

  const handleIsImport = (isImport: boolean) => {
    setIsImport(isImport);
  }

  return (
    <CreateView resourceSingular="event" validate={validate} transform={transform}>
      <EventForm
        sponsorLogo={sponsorLogo}
        eventLogo={eventLogo}
        selectedQuestions={selected}
        handleChangeSelectedQuestions={handleChangeSelected}
        reorderItems={moveCard}
        title="CREATE EVENT"
        handleChangeSponsorLogo={handleChangeSponsorLogo}
        handleChangeEventLogo={handleChangeEventLogo}
        agenda={agenda}
        rowModesModel={rowModesModel}
        handleChangeAgenda={handleChangeAgenda}
        handleChangeRowModesModel={handleChangeRowModesModel}
        handleClickAddAgenda={handleClickAddAgenda}
        handleIsImport={handleIsImport}
        isImport={isImport}
      />
    </CreateView>
  );
};
